import { DeeplinkKeys } from '@/consts/deepLinks';
import { MINIAPP_PACKAGE_ID } from '@/consts/configs';
import {
  PICSART_APP_URL,
  MOBILE_EDITOR_URL,
  PORTFOLIO_APP_URL,
} from '@/consts/urls';
import { isGenaiRoute, isPortfolioApp } from '@/utils/environment/surface';

import type { NotificationConfig } from '@/types';

import createDeeplinkUrl from './createDeeplinkUrl';
import extractUrlParams from './extractUrlParams';

const createNotificationConfig = (): NotificationConfig => {
  const isInCreateAndHome = isGenaiRoute();

  const { projectId } = extractUrlParams([DeeplinkKeys.projectId]);

  const deeplink = createDeeplinkUrl({
    baseUrl: isInCreateAndHome
      ? `${PICSART_APP_URL}/gen-ai`
      : `${PICSART_APP_URL}/create/editor`,
    params: !isInCreateAndHome
      ? {
          app: MINIAPP_PACKAGE_ID,
          projectId,
          category: 'miniapps',
        }
      : {},
  });

  // The portfolio app is a separate native app — the Picsart app scheme never
  // resolves there, so its notifications must deeplink into its own scheme.
  const mobileDeeplink = createDeeplinkUrl({
    baseUrl: isPortfolioApp() ? PORTFOLIO_APP_URL : MOBILE_EDITOR_URL,
    params: {
      mapp: MINIAPP_PACKAGE_ID,
      experience: 'default',
    },
  });

  return {
    ...(projectId && { projectId }),
    miniappPackageId: MINIAPP_PACKAGE_ID,
    actions: [
      {
        deeplink,
        mobileDeeplink,
      },
    ],
  };
};

export default createNotificationConfig;
